import React, { FC } from 'react';
import CookieConsentModal from 'common/components/CookieConsent/CookieConsent';
import LoginPopup from 'common/components/LoginPopupNew/LoginPopupMain';
import ResultsList from 'common/pages/SearchResultsRedesign/ResultsList';
// import MeetingRoomsImage from 'assets/img/meeting_room.png';
import VirtualOfficeImage from 'assets/img/virtual-office.jpeg';
import PrivateOfficeImage from 'assets/img/private-office.jpg';
import DesksImage from 'assets/img/desks.jpg';
import Header from 'common/components/Header/Header';
import ModalsProvider from './common/contexts/ModalsContext';
import QuickQuoteModal from './common/components/QuickQuoteModal/QuickQuoteModal';
import CommunicationTermsModal, {
  CommunicationTermsModalProps,
} from './common/components/CommunicationTerms/CommunicationTermsModal';
import PricingPlans from 'common/components/ProfilePage/PricingPlans/PricingPlans';
import { ResultListProvider } from 'common/contexts/ResultListContext';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from 'common/providers/ErrorBoundary';

const quickQuote = {
  completeLabel: 'complete',
  continueButtonLabel: 'CONTINUE',
  goBackButtonLabel: 'GO BACK',
  bookViewingStepCTALabel: 'Book a tour with one of our experts. It only takes a minute!',
  quickQuoteStepCTALabel: 'Enquire now with one of our experts. It only takes a minute!',
  bookAViewingLabel: 'Book a tour',
  quickQuoteLabel: 'Enquire Now',

  dateTimeStep: {
    title: 'When do you need it?',
    dateFieldLabel: 'Preferred viewing date',
    timeFieldLabel: 'Preferred viewing time',
    languageCode: 'en-gb',
    requiredLabel: 'This field is required',
    disabledDays: ['Sa', 'Su'],
  },
  peopleStep: {
    title: 'How many people is the office for?',
    options: [
      {
        text: '1',
        value: '1',
      },
      {
        text: '2',
        value: '2',
      },
      {
        text: '3-4',
        value: '4',
      },
      {
        text: '5-9',
        value: '7',
      },
      {
        text: '10-19',
        value: '15',
      },
      {
        text: '20-49',
        value: '35',
      },
      {
        text: '50-99',
        value: '75',
      },
    ],
    customOptions: [
      {
        text: '100+',
        minValue: 100,
        maxValue: 9999,
        numericValidationLabel: 'Invalid entry',
        minValueValidationLabel: 'This field should be a number greater than 100',
        maxValueValidationLabel: 'This field should be a number less than 9999',
      },
    ],
    customFieldLabel: 'Please specify',
    requiredLabel: 'This field is required',
  },
  officeTypeStep: {
    title: 'What are you looking for?',
    mobileTooltipTitle: 'Office types details',
    options: [
      {
        key: 4,
        text: 'Coworking Desks',
        value: 'hot_desk',
        singleVersionTitle: 'Coworking Desk',
        singleVersionValue: 'hot_desk',
        imageURL: DesksImage,
        description: 'To find your ideal office, our flexible office advisory team undertake extensive searches with a network of trusted office operators. A Coworker advisor will be in touch to discuss the best options for you.',
      },
      {
        key: 1,
        text: 'Private office',
        value: 'private_office',
        imageURL: PrivateOfficeImage,
        description: 'To find your ideal office, our flexible office advisory team undertake extensive searches with a network of trusted office operators. A Coworker advisor will be in touch to discuss the best options for you.',
      },
      {
        key: 6,
        text: 'Virtual office',
        value: 'virtual_office',
        imageURL: VirtualOfficeImage,
        description: 'A virtual office provides a physical address and office-related services such as a mailing address, phone answering services, meeting rooms, and videoconferencing. The physical office is not assigned and workspace may be used on an ad-hoc basis.',
      },
      /* {
        key: 8,
        text: 'Meeting room',
        value: 'meeting_room',
        imageURL: MeetingRoomsImage,
        description: 'To find your ideal office, our flexible office advisory team undertake extensive searches with a network of trusted office operators. A Coworker advisor will be in touch to discuss the best options for you.',
      }, */
      {
        key: 1,
        text: 'Not sure',
        value: 'other',
        imageURL: 'https://www.instantoffices.com/-/media/images/accommodation/not-sure.jpg',
      },
    ],
  },
  officeOptionsStep: {
    title: 'Which type of office do you require?',
    deskTitle: 'Which type of desks do you require?',
    singleVersionDeskTitle: 'Which type of desk do you require?',
    desksOptions: [
      {
        key: 7,
        text: 'Coworking Desks - Dedicated',
        value: 'Coworking Desks - Dedicated',
        singleVersionTitle: 'Coworking Desk - Dedicated',
        singleVersionValue: 'Coworking Desk - Dedicated',
        description: 'Normally in a coworking space, this desk would be dedicated to you and in a single location for you to access whenever you like. Usually includes services such as café, IT, and reception all provided within the monthly cost.',
      },
      {
        key: 8,
        text: 'Coworking Desks - Membership',
        value: 'Coworking Desks - Membership',
        singleVersionTitle: 'Coworking Desk - Membership',
        singleVersionValue: 'Coworking Desk - Membership',
        description: 'Normally in a coworking space, this desk membership would give you access to multiple locations so you can work whenever and wherever you like. Usually includes services such as café, IT, and a reception all provided within the monthly cost.',
      },
      {
        key: 3,
        text: 'Not Sure',
        value: 'Not Sure',
        description: 'If you\'re not sure don\'t worry, after you complete this enquiry a Coworker expert will help you with this decision.',
      },
    ],
    officesOptions: [
      {
        key: 4,
        text: 'Serviced Office',
        value: 'Serviced Office',
        description: 'A furnished workspace with services such as café, IT, cleaning and a reception all provided within the monthly cost.',
      },
      {
        key: 5,
        text: 'Leased Office',
        value: 'Leased Office',
        description: 'Normally unfurnished but provides workspace for you to complete as you wish. The monthly rent does not include any services such as IT, cleaning and maintenance.',
      },
      {
        key: 6,
        text: 'Managed Office',
        value: 'Managed Office',
        description: 'This is a bespoke office built to your requirements and design. The simple monthly cost includes all of your services such as cleaning, IT and maintenance.',
      },
      {
        key: 3,
        text: 'Not Sure',
        value: 'Not Sure',
        description: 'If you\'re not sure don\'t worry, after you complete this enquiry a Coworker expert will help you with this decision.',
      },
    ],
  },
  rentPeriodStep: {
    title: 'How long do you need it for?',
    options: [
      {
        text: '0-6 months',
        value: '0-6 months',
      },
      {
        text: '6-12 months',
        value: '6-12 months',
      },
      {
        text: '12 months +',
        value: '12 months +',
      },
      {
        text: 'Not sure',
        value: 'Not sure',
      },
    ],
  },
  availabilityStep: {
    waitingLabel: 'Please, wait a minute! We are checking the availability...',
  },
  loadingStep: {
    text: 'Retrieving the best price…',
  },
  bestPriceStep: {
    text: 'Great! We have the best price for this workspace.',
  },
  emailStep: {
    title: 'Great! We now all your requirements.',
    emailFieldCTA: 'Please enter your details so we can reach you:',
    emailFieldCTAExperimental: 'Please enter your details so we can reach you:',
    emailFieldLabel: 'Email',
    emailFieldValue: '',
    emailFieldMaxLength: 120,
    incorrectEmailLabel: 'Please input a valid email address',
    requiredLabel: 'This field is required',
    maxLengthLabel: '{0} cannot be longer than {1} characters',
    hint: {
      title: 'Why do we ask you?',
      text: 'To find your ideal office, our flexible office broking team undertake extensive searches with a network of trusted office operators. A Coworker broker or relevant office operator will be in touch by email and/or telephone to discuss the best options for you.',
    },
    firstNameFieldLabel: 'First name',
    phoneValidationLabel: 'Please input a valid phone number',
    specialCharactersLabel: 'Do not use special characters',
    fieldMaxLength: 120,
    communicationTermsText: 'By submitting your application and subscribing to our services, you agree that we may use your information and accept our conditions as set out in our',
    communicationTermsLinkLabel: 'Communication Terms',
    phoneFieldLabel: 'Phone',
  },
  phoneExperimentalStep: {
    title: 'What is your phone number?',
    phoneFieldLabel: 'Phone',
    requiredLabel: 'This field is required',
    phoneValidationLabel: 'Please input a valid phone number',
    chooseTheCountryLabel: 'Choose the country',
    searchForCountriesLabel: 'Search for countries',
    noResultsFound: 'No results found',
  },
  contactDataStep: {
    title: 'Almost there!',
    emailFieldLabel: 'Email',
    incorrectEmailLabel: 'Please input a valid email address',
    hint: {
      title: 'Why do we ask you?',
      text: 'To find your ideal office, our flexible office broking team undertake extensive searches with a network of trusted office operators. A Coworker broker or relevant office operator will be in touch by email and/or telephone to discuss the best options for you.',
    },
    firstNameFieldLabel: 'First name',
    lastNameFieldLabel: 'Last name',
    companyFieldLabel: 'Company',
    phoneFieldLabel: 'Phone',
    requiredLabel: 'This field is required',
    invalidEntryLabel: 'Invalid entry',
    phoneValidationLabel: 'Please input a valid phone number',
    specialCharactersLabel: 'Do not use special characters',
    fieldMaxLength: 120,
    maxLengthLabel: '{0} cannot be longer than {1} characters',
    chooseTheCountryLabel: 'Choose the country',
    searchForCountriesLabel: 'Search for countries',
    noResultsFound: 'No results found',
    dateFieldLabel: 'Estimated start date',
    userTime: '15:37',
    languageCode: 'en-gb',
    disabledDays: ['Sa', 'Su'],
    optionalLabel: '(optional)',
    captchaSiteKey: '6LcaVKAUAAAAAAfDTPgFv8tGuwrodh_Mv6_eJ0oT',
  },
  summaryStep: {
    title: 'Workspace Enquiry',
    successMessage: 'Your workspace enquiry has been sent!',
    inviteMessage: 'Want to invite friends of collegues to check out {0} too?',
    infoMessage: '{0} team will be in touch with you soon to confirm.',
    spaceName: 'Coworker',
    facebook: 'facebook.com/coworkerglobal',
    twitter: 'twitter.com/coworkerglobal',
    instagram: 'instagram.com/coworker/',
    loginMessage: ' on The Instant Group to book viewings, see your viewing schedules, download building reports and manage your buildings.',
  },
  cartAbandonmentStep: {
    askingQuestionsLabel: 'We’re asking you a few questions so we can send you a free quote. It won’t take long!',
    stayLabel: 'Stay',
    wantToLeaveLabel: 'Are you sure that you want to leave?',
    yesLeaveLabel: 'Yes, leave',
  },
  getPriceButtonLabel: 'SUBMIT',
  communicationTermsText: 'By submitting your application and subscribing to our services, you agree that we may use your information and accept our conditions as set out in our',
  communicationTermsLinkLabel: 'Communication Terms',
  globalTermsText: 'By submitting your application and subscribing to our services, you agree to our',
  // @ts-ignore
  globalTermsLink: `${window.location.origin || 'https://www.coworker.com/'}/terms`,
  globalTermsLinkLabel: 'Global Terms of Use',
  privacyPolicyTextStart: 'After you submit a workspace enquiry to us, we may share your enquiry details (including contact details) with workspace providers and our commercial broker partners, who may contact you to follow up on your enquiry. Please read our',
  privacyPolicyTextEnd: 'for details of how we process the information you provide.',
  // @ts-ignore
  privacyPolicyLink: `${window.location.origin || 'https://www.coworker.com/'}/privacy-policy`,
  privacyPolicyLinkLabel: 'Privacy and Cookies Policy',
};

const communicationTerms: CommunicationTermsModalProps = {
  modalProps: {
    content: '<p><strong>Our Services</strong>\n<br />\nTo find your ideal workspace, our advisors will undertake extensive searches with a network of trusted workspace providers (inc. landlords and commercial property agents). We share your enquiry details with them in order to locate the ideal space for you. Additionally, an account record is created at The Instant Group where you can request your viewings, download workspace reports, and manage your Workspaces. A member of the Instant team or service office provider may contact you by phone or email, to discuss your requirements.<br />\n<br />\n<strong>How We Use Your Information</strong><br />\n<br />\nPlease read our <a href="/privacy-policy" target="_blank">Privacy and Cookies Policy</a> for details of how we use and store the information you provide.</p>',
    labels: {
      'common.CommunicationTermsHeaderText': 'Communication Terms',
      'common.CommunicationTermsCloseBtnText': 'Close Window',
    },
  },
};

const cookieInfo = {
  cookieAcceptButton: 'Ok',
  cookieSettingsButton: 'Cookie settings',
  cookieHeader: 'This website uses cookies',
  cookieContent: 'We rely on cookies to enhance site navigation, analyse site usage, and assist in our marketing efforts. By continuing to browse or by clicking “Ok,” you agree to the storing of first- and third-party cookies on your device.',

  cookieGeneralInfo: 'A cookie is a small piece of data (text file) that a website, when visited by a user, asks your browser to store on your device in order to remember information about you, such as your language preferences or login information as an example. Those cookies are set by us and called first party cookies. We also use third party cookies, these cookies are from a domain different than the domain of the website you are visiting, used to understanding usage, improving site features or personalised advertising as an example. <br/> You can opt-out of each cookie category (except strictly necessary cookies) by turning these off in \'Cookie Preferences\' and selecting \'Update Settings\'. If you have any queries or require more information on this please email Privacy@theinstantgroup.com.',
  cookieStrictlyNecessary: 'These cookies are essential in order to enable you to use the key features of the site. Without these cookies we will not be able to connect you to the offices, properties, products or services you are looking for. These cookies cannot be switched off.',
  cookiePerformanceTargeting: 'Performance Cookies <br/> These cookies allow us to count visits and traffic sources, so we can measure and improve the performance of our site. They help us know which pages are the most and least popular and see how visitors use our product for future improvements. All information these cookies collect is aggregated and therefore anonymous. If you do not allow these cookies, we will not know when you have visited our site, also reducing the information available to improve our website in the future. <br/> Targeting Cookies <br/> These third-party cookies are set through our site by our advertising partners. They may be used by those companies to build a profile of your interests and show you relevant ads on other sites. They work by uniquely identifying your browser and device. If you do not allow these cookies, you will not experience targeted advertising across the websites.',
  cookieFunctional: 'These cookies allow us to remember choices you have made, such as previous searches to provide you a more enhanced, efficient and personal service. The information these cookies collect relates to our website only.',
  cookie3rdParty: 'Some of our pages use a third-party software provider, Optimizely, to test variations in functionality and content. This helps us constantly improve our website and deliver the best service and product to our visitors. This technology help us to continually improve the service and experience we provide you.',
};

const ReactApp: FC = () => (
  <ModalsProvider>
    <BrowserRouter>
      <ErrorBoundary>
        <ResultListProvider>
          <QuickQuoteModal quickQuote={quickQuote} />
          <CommunicationTermsModal {...communicationTerms} />
          <CookieConsentModal {...cookieInfo} />
          <LoginPopup />
          
          <ResultsList />
            
          <Header />
          <PricingPlans />
        </ResultListProvider>
      </ErrorBoundary>
    </BrowserRouter>
  </ModalsProvider>
);

export default ReactApp;
